<template>
  <v-container class="fill-height"
               fluid>
    <v-row align="center"
           justify="center">
      <v-col cols="12"
             sm="8"
             md="4">

        <v-form @submit.prevent="submit">
          <v-card elevation="12">
            <v-toolbar color="primary"
                       dark
                       flat>
              <v-toolbar-title>
                Reset Your Password
              </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field v-model="form.email"
                            type="email"
                            label="Email"
                            :error-messages="form.errors.get('email')"
                            required>
              </v-text-field>

              <v-text-field v-model="form.password"
                            type="password"
                            autocomplete="new-password"
                            label="Password"
                            :error-messages="form.errors.get('password')"
                            hint="Your password must have at least 8 characters"
                            persistent-hint
                            required>
              </v-text-field>

              <v-text-field v-model="form.password_confirmation"
                            type="password"
                            autocomplete="new-password"
                            label="Confirm Password"
                            :error-messages="form.errors.get('password_confirmation')"
                            required>
              </v-text-field>

            </v-card-text>
            <v-card-actions>
              <v-btn color="primary"
                     :disabled="form.busy"
                     type="submit">
                Reset Password
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>

        <v-alert type="success"
                 class="mt-3"
                 v-if="message">
                    <span>
                        {{ message }}
                    </span>
          <router-link :to="{name: 'login'}"
                       class="white--text">
            Log in now.
          </router-link>
        </v-alert>

      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {Form} from 'vform';

export default {
  data() {
    return {
      form: new Form({
        email: this.$route.query.email,
        password: '',
        password_confirmation: '',
        token: this.$route.params.token,
      }),
      message: null,
    }
  },
  created() {
    axios.get('/spark/token')
      .then()
      .catch(() => {
      });
  },
  methods: {
    submit() {
      this.message = null;
      this.form.post(`/password/reset`)
        .then(({data}) => {
          this.message = data.message;
        })
        .catch(() => {
        })
    }
  }
}
</script>
